import React from 'react';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import ErrorIcon from '@mui/icons-material/esm/Error';
import ListItem1 from 'Components/ComponentLibrary/Components/ListItems/ListItem1';
import ListItemText1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemText/ListItemText1';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';
import classNames from 'classnames';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const useStyles = buildUseStyles('MemberAlertsTooltipContent', (theme) => ({
  root: {
    padding: theme.spacing(0.5),
    maxWidth: theme.dimensions.sm,
  },
  listItem: {
    padding: theme.spacing(0),
    alignItems: 'start',
  },
  icon: {
    paddingRight: theme.spacing(1),
  },
}));

const MemberAlertsTooltipContent = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    householdResource,
  } = useSimpleHousehold();

  return (
    <List1 className={classNames(classes.root, className)}>
      {householdResource?.attr('memberAlerts').map((alert) => {
        return (
          <ListItem1 className={classes.listItem}>
            <Icon icon={ErrorIcon} className={classes.icon} />
            <ListItemText1
              color={'white'}
              primary={alert}
              primaryTypographyProps={{
                variant: 'h6',
              }}
            />
          </ListItem1>);
      })}
    </List1>
  );
};

MemberAlertsTooltipContent.defaultProps = {
  className: '',
};

MemberAlertsTooltipContent.propTypes = {
  className: PropTypes.string,
};

export default MemberAlertsTooltipContent;
